<template>
  <div class="caretaker">
    <div v-for="(caretaker, index) in storeState.caretakers" v-bind:key="index">
       <h2 class="text-xl mt-5 text-pilke-primary">{{index + 1}}. Huoltaja</h2>
       <Caretaker
         :caretaker="caretaker"
         :store="store" />
       <div class="text-left">
          <button @click="store.removeCaretaker(index)" class="btn delete">Poista huoltaja</button>
       </div>
    </div>

    <button class="btn btn-default" type="button" @click="addCaretaker()">Lisää uusi huoltaja</button>

    <p class="text-center mt-5 text-pilke-primary">Hakemuksellasi on <span class="font-medium">{{storeState.caretakers.length}}</span> huoltajaa</p>

  </div>
</template>

<script>
import Caretaker from '../components/Caretaker.vue'

export default {
   name: 'caretaker',

   props: ['store'],

   components: {
      Caretaker
   },

   data () {
      return {
         storeState: this.store.state
      }
   },

   methods: {
      addCaretaker () {
         this.store.addCaretaker()
      }
   }
}
</script>

<style scoped>
</style>
